/** `seed`: the Seed design (2026-10-17), built beside `revamped` so the two can be compared. */
export type DesignVersion = "legacy" | "revamped" | "seed";
export const DESIGN_KEY = "nexseed.design";
export const DESIGN_THEME_KEY = "nexseed.design.theme";

/** Explicit URL choice wins; unrelated navigation retains the current session. */
export function resolveDesign(
  search: string,
  remembered: string | null
): DesignVersion {
  const explicit = new URLSearchParams(search).get("design");
  if (explicit === "legacy" || explicit === "revamped" || explicit === "seed")
    return explicit;
  return remembered === "revamped" || remembered === "seed"
    ? remembered
    : "legacy";
}
